// IOCType is the in-page graph classifier output. Kept narrow because every
// downstream Record<IOCType, X> would need updating. Wider IOC categorization
// — ASN, CVE, MITRE, crypto wallets etc. — lives in the registry and is keyed
// by `category` (a string), not by IOCType.
export type IOCType = 'IP' | 'DOMAIN' | 'HASH' | 'URL' | 'EMAIL' | 'UNKNOWN';

export function classifyIOC(value: string): IOCType {
  if (/^\d{1,3}(\.\d{1,3}){3}$/.test(value)) return 'IP';
  if (/^https?:\/\//.test(value)) return 'URL';
  if (/@/.test(value)) return 'EMAIL';
  if (/^[a-f0-9]{64}$/i.test(value)) return 'HASH';
  if (/^[a-f0-9]{40}$/i.test(value)) return 'HASH';
  if (/^[a-f0-9]{32}$/i.test(value)) return 'HASH';
  if (/^[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z]{2,})+$/i.test(value)) return 'DOMAIN';
  return 'UNKNOWN';
}

export const IOC_LANE_TYPES: IOCType[] = ['IP', 'DOMAIN', 'HASH', 'URL', 'EMAIL'];
